<nb-card class="spreadsheet-card-wrapper h-100">
  <nb-card-body class="spreadsheet p-0">
        <!-- Export row -->
        <div class="row mx-0 spreadsheet-top-row">
          <div class="col-12 top-right-buttons">
            <button
              nbButton ghost status="primary"
              (click)="exportInitiative()"
              nbTooltip="{{ 'Export excel' | translate }}"
              nbTooltipPlacement="left"
              class="excel-button"
            >
              <fa-icon [icon]="['fal', 'file-arrow-down']" size="xl"></fa-icon>
            </button>
          </div>
        </div>
        <!-- En-tête -->
        <div class="row header-container">
          <!-- Total budget -->
          <div class="spreadsheet-summary" [class]="!minimizedView ? 'col-9' : 'col-7'">
            @if (!!totalInitiatives) {
              <span>
                {{ 'pages.energy.spreadsheet.summary_sentence' | translate:{
                totalInitiatives: totalInitiatives, co2Savings: co2Savings, kwhSavings: kwhSavings
                } }}
              </span>
            }
          </div>
          <!-- Gestion des filtres -->
          <div class="px-0" [class]="!minimizedView ? 'col-3' : 'col-5'">
            <app-table-filter [filtersNb]="filtersNb" tableType="initiative">
            </app-table-filter>
          </div>
        </div>
        <div style="height: calc(100% - 128px);">
          <app-ag-grid-initiative
            #grid
            (filtersNb)="filtersNb = $event"
            (savingsSummary)="savingsSummaryUpdated($event)"
            [inputFilters]="inputFilters"
            [inputColumns]="inputColumns"
            [inputScenario]="inputScenario"
            [showScenarii]="showScenarii"
            [project]="project"
            [isFidjiAct]="isFidjiAct"
            >
          </app-ag-grid-initiative>
        </div>
        <div class="row footer-container">
          {{ 'pages.energy.spreadsheet.summary_precision' | translate }}
        </div>
  </nb-card-body>
</nb-card>
